import { IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';

// Upload state of a data package file descriptor, derived from the two flags the
// uploader persists (`isError`, `isComplete`). These are the single source of truth
// for "has this file actually finished uploading?" — the uploader grid uses them to
// pick a row's controls, and the required-file-type validation uses them to decide
// whether a file may satisfy a required type. Keeping both on the same predicates is
// what guarantees the Submit button can never be enabled while a row still renders
// as Uploading or Failed (DEV-699).

export const isFileUploadFailed = (file: IDataPackageFileDescriptor): boolean => !!file?.isError;

export const isFileUploadInProgress = (file: IDataPackageFileDescriptor): boolean => !isFileUploadFailed(file) && !file?.isComplete;

export const isFileUploadComplete = (file: IDataPackageFileDescriptor): boolean => !isFileUploadFailed(file) && !!file?.isComplete;
